import { NavigationIcon } from './NavigationIcon';

/**
 * author: Google
 * id DAAF6988-6EE9-4595-A758-294C83C7304B
 * name navigation
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/navigation.svg
 * tags
 * - Navigation 
 */
export const ArrowCompassIcon = NavigationIcon;
export default ArrowCompassIcon